import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  version: "1.1",
  id: "レイヤー_1",
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  x: "0px",
  y: "0px",
  viewBox: "0 0 720 700",
  "xml:space": "preserve",
  style: {"min-width":"200px","max-width":"800px"}
}
const _hoisted_2 = ["fill"]
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  fill: "none",
  stroke: "#000000",
  "stroke-width": "2",
  "stroke-miterlimit": "10",
  d: "M580.926,258.908\n\t\tc4.68-3.979,15.823-12.637,25.604-12.417c9.779,0.22,30.548-1.209,34.394,8.571c3.847,9.779,5.274,20.987-2.417,24.614\n\t\tc-7.692,3.626-11.429,5.934-14.615,8.46c-3.187,2.528-10.658,8.988-17.691,7.571c-7.032-1.417-11.099-4.164-15.823-5.154\n\t\tc-4.725-0.987-8.352-0.438-12.417-0.987c-4.065-0.55-10.056-5.935-10.879-8.022c-0.822-2.087-2.308-7.143,2.638-13.076\n\t\tC574.662,262.534,577.798,261.568,580.926,258.908z"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("path", {
  fill: "none",
  stroke: "#000000",
  "stroke-width": "2",
  "stroke-miterlimit": "10",
  d: "M582.135,273.083c2.197-1.209,2.856,0,7.143,3.187\n\t\tc4.285,3.187,15.823,0.879,18.681,0.55c0.682-0.079,1.42-0.038,2.199,0.096c2.487,0.427,5.396,1.805,8.239,3.311\n\t\tc3.736,1.979,8.765,3.124,13.837,1.476"
}, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("path", {
  fill: "none",
  stroke: "#000000",
  "stroke-width": "2",
  "stroke-miterlimit": "10",
  d: "M617.188,266.599\n\t\tc0,2.527-5.618,10.109-7.832,10.219"
}, null, -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("path", {
  fill: "none",
  stroke: "#000000",
  "stroke-width": "2",
  "stroke-miterlimit": "10",
  d: "M606.494,277.023\n\t\tc-1.613,1.334-6.668,7.048-8.097,9.355"
}, null, -1)
const _hoisted_7 = ["fill"]
const _hoisted_8 = /*#__PURE__*/_createElementVNode("path", {
  fill: "none",
  stroke: "#000000",
  "stroke-width": "2",
  "stroke-miterlimit": "10",
  d: "M563.737,225.596\n\t\tc9.227-6.949,12.967-10.769,17.472-13.405c4.506-2.638,14.065-8.462,25.383-5.604c11.319,2.857,21.868,7.692,25.384,16.373\n\t\tc3.517,8.681,1.209,18.021-2.197,20.328s-8.9,2.198-12.856,7.253s-11.099,6.923-16.043,6.044\n\t\tc-4.945-0.88-15.934-4.506-20.988-3.956c-5.055,0.549-19.34-0.439-22.746-5.604C553.738,241.86,554.691,232.41,563.737,225.596z"
}, null, -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("path", {
  fill: "none",
  stroke: "#000000",
  "stroke-width": "2",
  "stroke-miterlimit": "10",
  d: "M565.63,239.222\n\t\tc1.429-3.187,9.011-3.517,11.428-1.538c2.418,1.978,21.758,6.044,25.273,4.944c3.517-1.099,7.692,1.813,11.538,2.83\n\t\ts12.132-0.402,12.9-0.731"
}, null, -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("path", {
  fill: "none",
  stroke: "#000000",
  "stroke-width": "2",
  "stroke-miterlimit": "10",
  d: "M590,249.112c3.626-0.77,12.52-4.099,13.622-6.72"
}, null, -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("path", {
  fill: "none",
  stroke: "#000000",
  "stroke-width": "2",
  "stroke-miterlimit": "10",
  d: "M610.878,227.684\n\t\tc-0.053,2.635-8.256,15.41-11.528,15.1"
}, null, -1)
const _hoisted_12 = ["fill"]
const _hoisted_13 = /*#__PURE__*/_createElementVNode("path", {
  fill: "none",
  stroke: "#000000",
  "stroke-width": "2",
  "stroke-miterlimit": "10",
  d: "M546.414,187.192\n\t\tc3.982-2.336,14.418-8.682,19.9-10.439c5.483-1.758,19.328-2.638,25.263-0.879c5.934,1.758,16.593,12.674,18.79,16.666\n\t\tc2.198,3.992,2.638,17.398-4.396,19.596c-7.032,2.198-14.065,2.967-16.372,5.604c-2.308,2.638-11.538,9.011-17.362,7.252\n\t\tc-5.824-1.758-10.201-5.384-15.54-5.055c-5.338,0.33-19.953-3.517-21.821-8.351C533.009,206.752,534.393,194.244,546.414,187.192z"
}, null, -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("path", {
  fill: "none",
  stroke: "#000000",
  "stroke-width": "2",
  "stroke-miterlimit": "10",
  d: "M552.019,203.785\n\t\tc2.967-1.209,5.934,0.549,11.099,2.087c5.164,1.539,14.944,2.309,18.24,0c3.297-2.308,4.726,4.725,9.67,6.044\n\t\tc4.945,1.318,12.265,1.235,12.596,0.905"
}, null, -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("path", {
  fill: "none",
  stroke: "#000000",
  "stroke-width": "2",
  "stroke-miterlimit": "10",
  d: "M562.897,214.223\n\t\tc4.615-0.438,16.05-5.258,17.364-7.793"
}, null, -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("path", {
  fill: "none",
  stroke: "#000000",
  "stroke-width": "2",
  "stroke-miterlimit": "10",
  d: "M589.599,193.345\n\t\tc0.66,1.978-0.879,6.483-1.979,7.472"
}, null, -1)
const _hoisted_17 = ["fill"]
const _hoisted_18 = /*#__PURE__*/_createElementVNode("path", {
  fill: "none",
  stroke: "#000000",
  "stroke-width": "2",
  "stroke-miterlimit": "10",
  d: "M526.363,158.975\n\t\tc11.169-8.872,16.153-17.472,25.823-14.615c9.67,2.857,15.604,13.167,17.911,17.792s5.164,11.768,0,17.042\n\t\tc-5.165,5.274-13.846,9.765-18.021,9.882s-4.505,3.305-9.67,3.305c-5.164,0-11.646,1.647-16.043-2.198\n\t\ts-12.197-10.438-13.296-15.054C511.969,170.513,524.348,160.577,526.363,158.975z"
}, null, -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("path", {
  fill: "none",
  stroke: "#000000",
  "stroke-width": "2",
  "stroke-miterlimit": "10",
  d: "M521.528,175.238\n\t\tc4.615-1.099,10.659,4.286,15.934,6.373c5.274,2.088,11.428,1.1,15.604,0c4.176-1.099,6.812-2.879,9.779-2.648"
}, null, -1)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("path", {
  fill: "none",
  stroke: "#000000",
  "stroke-width": "2",
  "stroke-miterlimit": "10",
  d: "M531.528,186.336\n\t\tc4.812,0.33,10.066-3.298,11.469-3.503"
}, null, -1)
const _hoisted_21 = ["fill"]
const _hoisted_22 = /*#__PURE__*/_createElementVNode("path", {
  fill: "none",
  stroke: "#000000",
  "stroke-width": "2",
  "stroke-miterlimit": "10",
  d: "M496.121,157.596\n\t\tc-0.383-7.087,7.879-29.187,10.637-33.846c2.76-4.659,7.483-12.276,10.638-12.628s8.762,4.129,11.43,6.889\n\t\tc2.669,2.76,7.996,12.972,8.904,21.309c0.908,8.339,0.844,12.582,0.547,16.796c-0.296,4.212-1.172,10.399-4.925,11.794\n\t\tc-3.752,1.395-13.448,3.591-18.485,3.001S496.921,172.421,496.121,157.596z"
}, null, -1)
const _hoisted_23 = ["fill"]
const _hoisted_24 = /*#__PURE__*/_createElementVNode("path", {
  fill: "none",
  stroke: "#000000",
  "stroke-width": "2",
  "stroke-miterlimit": "10",
  d: "M474.145,93.009\n\t\tc-4.374,1.122-8.883,3.36-11.783,8.542c-2.902,5.181-9.599,18.827-10.1,20.052c-0.841,2.052-0.648,7.126,1.829,11.516\n\t\tc1.306,2.312,3.904,4.243,5.89,5.856c5.753,4.676,14.225,11.036,15.282,11.863c1.058,0.828,8.261,2.914,15.377-1.096\n\t\ts18.414-8.47,17.612-11.967c-0.801-3.496-5.633-22.022-9.358-28.005C495.168,103.788,483.952,90.493,474.145,93.009z"
}, null, -1)
const _hoisted_25 = ["fill"]
const _hoisted_26 = /*#__PURE__*/_createElementVNode("path", {
  fill: "none",
  stroke: "#000000",
  "stroke-width": "2",
  "stroke-miterlimit": "10",
  d: "M427.564,78.348\n\t\tc-3.053,2.053-12.24,11.102-15.602,17.374c-3.26,6.081-5.604,19.963-2.967,29.694c2.637,9.729,9.993,9.259,19.12,8.847\n\t\tc9.732-0.441,15.091-1.592,17.142-1.927c2.052-0.336,8.352-1.007,10.109-10.065c1.76-9.06,1.476-16.987,1.508-17.993\n\t\tc0.133-4.278-2.044-11.421-4.805-15.601c-3.406-5.159-9.983-10.945-12.614-11.162C436.797,77.294,430.092,76.649,427.564,78.348z"
}, null, -1)
const _hoisted_27 = ["fill"]
const _hoisted_28 = /*#__PURE__*/_createElementVNode("path", {
  fill: "none",
  stroke: "#000000",
  "stroke-width": "2",
  "stroke-miterlimit": "10",
  d: "M382.458,67.596\n\t\tc9.375,0.209,21.552,12.798,25.361,33.466c3.81,20.668-4.103,28.335-13.626,28.669c-9.523,0.333-31.493,2.44-35.596,0.44\n\t\tc-4.102-2-5.056-17.442-3.523-24.109C358.426,91.477,367.514,67.263,382.458,67.596z"
}, null, -1)
const _hoisted_29 = ["fill"]
const _hoisted_30 = /*#__PURE__*/_createElementVNode("path", {
  fill: "none",
  stroke: "#000000",
  "stroke-width": "2",
  "stroke-miterlimit": "10",
  d: "M127.074,258.908\n\t\tc-4.68-3.979-15.824-12.637-25.604-12.417c-9.779,0.22-30.547-1.209-34.393,8.571c-3.846,9.779-5.275,20.987,2.417,24.614\n\t\tc7.692,3.626,11.428,5.934,14.615,8.46c3.187,2.528,10.659,8.988,17.692,7.571c7.032-1.417,11.098-4.164,15.823-5.154\n\t\tc4.725-0.987,8.351-0.438,12.417-0.987c4.066-0.55,10.055-5.935,10.878-8.022c0.823-2.087,2.308-7.143-2.637-13.076\n\t\tS130.202,261.568,127.074,258.908z"
}, null, -1)
const _hoisted_31 = /*#__PURE__*/_createElementVNode("path", {
  fill: "none",
  stroke: "#000000",
  "stroke-width": "2",
  "stroke-miterlimit": "10",
  d: "M125.865,273.083c-2.198-1.209-2.857,0-7.143,3.187\n\t\tc-4.285,3.187-15.823,0.879-18.68,0.55c-0.682-0.079-1.42-0.038-2.2,0.096c-2.487,0.427-5.379,1.835-8.239,3.311\n\t\tc-4.262,2.2-6.937,4.519-11.72,2.748"
}, null, -1)
const _hoisted_32 = /*#__PURE__*/_createElementVNode("path", {
  fill: "none",
  stroke: "#000000",
  "stroke-width": "2",
  "stroke-miterlimit": "10",
  d: "M90.812,266.599c0,2.527,5.619,10.109,7.833,10.219\n\t\t"
}, null, -1)
const _hoisted_33 = /*#__PURE__*/_createElementVNode("path", {
  fill: "none",
  stroke: "#000000",
  "stroke-width": "2",
  "stroke-miterlimit": "10",
  d: "M101.506,277.023\n\t\tc1.613,1.334,6.668,7.048,8.097,9.355"
}, null, -1)
const _hoisted_34 = ["fill"]
const _hoisted_35 = /*#__PURE__*/_createElementVNode("path", {
  fill: "none",
  stroke: "#000000",
  "stroke-width": "2",
  "stroke-miterlimit": "10",
  d: "M144.263,225.596\n\t\tc-9.227-6.949-12.966-10.769-17.472-13.405c-4.505-2.638-14.065-8.462-25.383-5.604s-21.867,7.692-25.384,16.373\n\t\tc-3.516,8.681-1.208,18.021,2.198,20.328c3.406,2.308,8.901,2.198,12.856,7.253c3.956,5.055,11.099,6.923,16.044,6.044\n\t\tc4.945-0.88,15.933-4.506,20.988-3.956c5.054,0.549,19.34-0.439,22.746-5.604C154.263,241.86,153.309,232.41,144.263,225.596z"
}, null, -1)
const _hoisted_36 = /*#__PURE__*/_createElementVNode("path", {
  fill: "none",
  stroke: "#000000",
  "stroke-width": "2",
  "stroke-miterlimit": "10",
  d: "M142.504,239.222\n\t\tc-1.428-3.187-9.011-3.517-11.428-1.538c-2.418,1.978-21.757,6.044-25.274,4.944c-3.516-1.099-7.692,1.813-11.537,2.83\n\t\tc-3.846,1.017-5.32,1.572-7.44,0.86"
}, null, -1)
const _hoisted_37 = /*#__PURE__*/_createElementVNode("path", {
  fill: "none",
  stroke: "#000000",
  "stroke-width": "2",
  "stroke-miterlimit": "10",
  d: "M118,249.112c-3.626-0.77-12.52-4.099-13.622-6.72"
}, null, -1)
const _hoisted_38 = /*#__PURE__*/_createElementVNode("path", {
  fill: "none",
  stroke: "#000000",
  "stroke-width": "2",
  "stroke-miterlimit": "10",
  d: "M97.122,227.684\n\t\tc-0.66,1.319,8.256,15.41,11.528,15.1"
}, null, -1)
const _hoisted_39 = ["fill"]
const _hoisted_40 = /*#__PURE__*/_createElementVNode("path", {
  fill: "none",
  stroke: "#000000",
  "stroke-width": "2",
  "stroke-miterlimit": "10",
  d: "M161.586,187.192\n\t\tc-3.982-2.336-14.417-8.682-19.9-10.439c-5.484-1.758-19.329-2.638-25.263-0.879c-5.934,1.758-16.593,12.674-18.79,16.666\n\t\tc-2.198,3.992-2.637,17.398,4.395,19.596c7.033,2.198,14.065,2.967,16.373,5.604s11.538,9.011,17.362,7.252\n\t\tc5.823-1.758,10.201-5.384,15.539-5.055c5.339,0.33,19.953-3.517,21.822-8.351C174.992,206.752,173.608,194.244,161.586,187.192z"
}, null, -1)
const _hoisted_41 = /*#__PURE__*/_createElementVNode("path", {
  fill: "none",
  stroke: "#000000",
  "stroke-width": "2",
  "stroke-miterlimit": "10",
  d: "M155.981,203.785\n\t\tc-2.967-1.209-5.934,0.549-11.098,2.087c-5.165,1.539-14.944,2.309-18.241,0c-3.297-2.308-4.725,4.725-9.67,6.044\n\t\tc-4.945,1.318-7.147,1.403-11.318,0"
}, null, -1)
const _hoisted_42 = /*#__PURE__*/_createElementVNode("path", {
  fill: "none",
  stroke: "#000000",
  "stroke-width": "2",
  "stroke-miterlimit": "10",
  d: "M145.103,214.223\n\t\tc-4.615-0.438-16.05-5.258-17.365-7.793"
}, null, -1)
const _hoisted_43 = /*#__PURE__*/_createElementVNode("path", {
  fill: "none",
  stroke: "#000000",
  "stroke-width": "2",
  "stroke-miterlimit": "10",
  d: "M118.401,193.345\n\t\tc-0.659,1.978,0.879,6.483,1.978,7.472"
}, null, -1)
const _hoisted_44 = ["fill"]
const _hoisted_45 = /*#__PURE__*/_createElementVNode("path", {
  fill: "none",
  stroke: "#000000",
  "stroke-width": "2",
  "stroke-miterlimit": "10",
  d: "M181.637,158.975\n\t\tc-11.169-8.872-16.153-17.472-25.823-14.615c-9.67,2.857-15.604,13.167-17.911,17.792c-2.308,4.625-5.165,11.768,0,17.042\n\t\tc5.164,5.274,13.845,9.765,18.021,9.882c4.175,0.117,4.505,3.305,9.67,3.305s11.647,1.647,16.043-2.198\n\t\ts12.197-10.438,13.296-15.054C196.032,170.513,183.653,160.577,181.637,158.975z"
}, null, -1)
const _hoisted_46 = /*#__PURE__*/_createElementVNode("path", {
  fill: "none",
  stroke: "#000000",
  "stroke-width": "2",
  "stroke-miterlimit": "10",
  d: "M186.472,175.238\n\t\tc-4.615-1.099-10.659,4.286-15.934,6.373c-5.274,2.088-11.427,1.1-15.603,0c-4.176-1.099-6.813-2.879-9.78-2.648"
}, null, -1)
const _hoisted_47 = /*#__PURE__*/_createElementVNode("path", {
  fill: "none",
  stroke: "#000000",
  "stroke-width": "2",
  "stroke-miterlimit": "10",
  d: "M176.472,186.336\n\t\tc-4.835-1.429-10.082-4.479-11.469-3.503"
}, null, -1)
const _hoisted_48 = ["fill"]
const _hoisted_49 = /*#__PURE__*/_createElementVNode("path", {
  fill: "none",
  stroke: "#000000",
  "stroke-width": "2",
  "stroke-miterlimit": "10",
  d: "M211.879,157.596\n\t\tc0.382-7.087-7.879-29.187-10.637-33.846c-2.759-4.659-7.484-12.276-10.638-12.628c-3.155-0.352-8.762,4.129-11.43,6.889\n\t\ts-7.996,12.972-8.904,21.309c-0.909,8.339-0.843,12.582-0.547,16.796c0.296,4.212,1.172,10.399,4.925,11.794\n\t\tc3.752,1.395,13.448,3.591,18.485,3.001C198.171,170.321,211.079,172.421,211.879,157.596z"
}, null, -1)
const _hoisted_50 = ["fill"]
const _hoisted_51 = /*#__PURE__*/_createElementVNode("path", {
  fill: "none",
  stroke: "#000000",
  "stroke-width": "2",
  "stroke-miterlimit": "10",
  d: "M233.855,93.009\n\t\tc4.374,1.122,8.882,3.36,11.784,8.542c2.901,5.181,9.598,18.827,10.099,20.052c0.84,2.052,0.649,7.126-1.83,11.516\n\t\tc-1.305,2.312-3.904,4.243-5.889,5.856c-5.753,4.676-14.225,11.036-15.282,11.863c-1.057,0.828-8.261,2.914-15.377-1.096\n\t\tc-7.116-4.01-18.414-8.47-17.612-11.967c0.801-3.496,5.632-22.022,9.358-28.005C212.833,103.788,224.047,90.493,233.855,93.009z"
}, null, -1)
const _hoisted_52 = ["fill"]
const _hoisted_53 = /*#__PURE__*/_createElementVNode("path", {
  fill: "none",
  stroke: "#000000",
  "stroke-width": "2",
  "stroke-miterlimit": "10",
  d: "M280.435,78.348\n\t\tc3.054,2.053,12.24,11.102,15.602,17.374c3.26,6.081,5.605,19.963,2.967,29.694c-2.637,9.729-9.993,9.259-19.12,8.847\n\t\tc-9.733-0.441-15.091-1.592-17.142-1.927c-2.051-0.336-8.351-1.007-10.109-10.065c-1.759-9.06-1.476-16.987-1.508-17.993\n\t\tc-0.133-4.278,2.043-11.421,4.804-15.601c3.406-5.159,9.984-10.945,12.614-11.162C271.203,77.294,277.908,76.649,280.435,78.348z"
}, null, -1)
const _hoisted_54 = ["fill"]
const _hoisted_55 = /*#__PURE__*/_createElementVNode("path", {
  fill: "none",
  stroke: "#000000",
  "stroke-width": "2",
  "stroke-miterlimit": "10",
  d: "M325.542,67.596\n\t\tc-9.375,0.209-21.552,12.798-25.361,33.466c-3.809,20.668,4.102,28.335,13.626,28.669c9.523,0.333,31.492,2.44,35.595,0.44\n\t\tc4.102-2,5.056-17.442,3.524-24.109C349.575,91.477,340.486,67.263,325.542,67.596z"
}, null, -1)
const _hoisted_56 = ["fill"]
const _hoisted_57 = /*#__PURE__*/_createElementVNode("path", {
  fill: "none",
  stroke: "#000000",
  "stroke-width": "2",
  "stroke-miterlimit": "10",
  d: "M580.926,374.638\n\t\tc4.68,3.979,15.823,12.637,25.604,12.417c9.779-0.22,30.548,1.208,34.394-8.571c3.847-9.78,5.274-20.988-2.417-24.614\n\t\tc-7.692-3.626-11.429-5.934-14.615-8.46c-3.187-2.528-10.658-8.989-17.691-7.572c-7.032,1.418-11.099,4.165-15.823,5.153\n\t\tc-4.725,0.989-8.352,0.439-12.417,0.989s-10.056,5.935-10.879,8.021c-0.822,2.087-2.308,7.143,2.638,13.076\n\t\tC574.662,371.011,577.798,371.978,580.926,374.638z"
}, null, -1)
const _hoisted_58 = /*#__PURE__*/_createElementVNode("path", {
  fill: "none",
  stroke: "#000000",
  "stroke-width": "2",
  "stroke-miterlimit": "10",
  d: "M582.135,360.462c2.197,1.209,2.856,0,7.143-3.187\n\t\tc4.285-3.187,15.823-0.879,18.681-0.549c0.682,0.078,1.42,0.038,2.199-0.096c2.487-0.427,5.396-1.806,8.239-3.312\n\t\tc3.736-1.978,8.616-4.301,13.688-2.652"
}, null, -1)
const _hoisted_59 = /*#__PURE__*/_createElementVNode("path", {
  fill: "none",
  stroke: "#000000",
  "stroke-width": "2",
  "stroke-miterlimit": "10",
  d: "M617.188,366.946\n\t\tc0-2.527-5.618-10.109-7.832-10.219"
}, null, -1)
const _hoisted_60 = /*#__PURE__*/_createElementVNode("path", {
  fill: "none",
  stroke: "#000000",
  "stroke-width": "2",
  "stroke-miterlimit": "10",
  d: "M606.494,356.523\n\t\tc-1.613-1.335-6.668-7.049-8.097-9.356"
}, null, -1)
const _hoisted_61 = ["fill"]
const _hoisted_62 = /*#__PURE__*/_createElementVNode("path", {
  fill: "none",
  stroke: "#000000",
  "stroke-width": "2",
  "stroke-miterlimit": "10",
  d: "M563.737,407.949\n\t\tc9.227,6.949,12.967,10.769,17.472,13.406c4.506,2.637,14.065,8.461,25.383,5.604c11.319-2.856,21.868-7.691,25.384-16.372\n\t\tc3.517-8.682,1.209-18.021-2.197-20.329s-8.9-2.197-12.856-7.252s-11.099-6.923-16.043-6.044\n\t\tc-4.945,0.879-15.934,4.505-20.988,3.956c-5.055-0.55-19.34,0.439-22.746,5.604C553.738,391.686,554.691,401.137,563.737,407.949z"
}, null, -1)
const _hoisted_63 = /*#__PURE__*/_createElementVNode("path", {
  fill: "none",
  stroke: "#000000",
  "stroke-width": "2",
  "stroke-miterlimit": "10",
  d: "M565.495,394.323\n\t\tc1.429,3.188,9.011,3.517,11.429,1.539c2.417-1.979,21.757-6.044,25.273-4.945s7.691-1.813,11.538-2.829\n\t\tc3.846-1.017,8.79-0.624,9.56-0.294"
}, null, -1)
const _hoisted_64 = /*#__PURE__*/_createElementVNode("path", {
  fill: "none",
  stroke: "#000000",
  "stroke-width": "2",
  "stroke-miterlimit": "10",
  d: "M590,384.433c3.626,0.77,12.52,4.1,13.622,6.72"
}, null, -1)
const _hoisted_65 = /*#__PURE__*/_createElementVNode("path", {
  fill: "none",
  stroke: "#000000",
  "stroke-width": "2",
  "stroke-miterlimit": "10",
  d: "M610.878,405.861\n\t\tc0.659-1.318-8.256-15.409-11.528-15.1"
}, null, -1)
const _hoisted_66 = ["fill"]
const _hoisted_67 = /*#__PURE__*/_createElementVNode("path", {
  fill: "none",
  stroke: "#000000",
  "stroke-width": "2",
  "stroke-miterlimit": "10",
  d: "M546.414,446.354\n\t\tc3.982,2.336,14.418,8.681,19.9,10.438c5.483,1.76,19.328,2.639,25.263,0.881c5.934-1.759,16.593-12.674,18.79-16.666\n\t\tc2.198-3.993,2.638-17.398-4.396-19.597c-7.032-2.197-14.065-2.967-16.372-5.604c-2.308-2.638-11.538-9.011-17.362-7.253\n\t\tc-5.824,1.759-10.201,5.385-15.54,5.055c-5.338-0.329-19.953,3.518-21.821,8.352C533.009,426.794,534.393,439.301,546.414,446.354z\n\t\t"
}, null, -1)
const _hoisted_68 = /*#__PURE__*/_createElementVNode("path", {
  fill: "none",
  stroke: "#000000",
  "stroke-width": "2",
  "stroke-miterlimit": "10",
  d: "M552.019,429.761\n\t\tc2.967,1.209,5.934-0.55,11.099-2.088c5.164-1.538,14.944-2.309,18.24,0c3.297,2.308,4.726-4.724,9.67-6.044\n\t\tc4.945-1.318,10.989-1.578,11.318-1.248"
}, null, -1)
const _hoisted_69 = /*#__PURE__*/_createElementVNode("path", {
  fill: "none",
  stroke: "#000000",
  "stroke-width": "2",
  "stroke-miterlimit": "10",
  d: "M562.897,419.322\n\t\tc4.615,0.439,16.05,5.258,17.364,7.794"
}, null, -1)
const _hoisted_70 = /*#__PURE__*/_createElementVNode("path", {
  fill: "none",
  stroke: "#000000",
  "stroke-width": "2",
  "stroke-miterlimit": "10",
  d: "M589.599,440.201\n\t\tc0.66-1.979-0.879-6.483-1.979-7.473"
}, null, -1)
const _hoisted_71 = ["fill"]
const _hoisted_72 = /*#__PURE__*/_createElementVNode("path", {
  fill: "none",
  stroke: "#000000",
  "stroke-width": "2",
  "stroke-miterlimit": "10",
  d: "M526.363,474.571\n\t\tc11.169,8.872,16.153,17.472,25.823,14.614c9.67-2.856,15.604-13.166,17.911-17.791s5.164-11.768,0-17.042\n\t\tc-5.165-5.275-13.846-9.765-18.021-9.883c-4.176-0.117-4.505-3.304-9.67-3.304c-5.164,0-11.646-1.648-16.043,2.197\n\t\tc-4.396,3.847-12.197,10.439-13.296,15.055S524.348,472.969,526.363,474.571z"
}, null, -1)
const _hoisted_73 = /*#__PURE__*/_createElementVNode("path", {
  fill: "none",
  stroke: "#000000",
  "stroke-width": "2",
  "stroke-miterlimit": "10",
  d: "M521.528,458.307\n\t\tc4.615,1.1,10.659-4.285,15.934-6.373s11.428-1.099,15.604,0s6.812,2.88,9.779,2.648"
}, null, -1)
const _hoisted_74 = /*#__PURE__*/_createElementVNode("path", {
  fill: "none",
  stroke: "#000000",
  "stroke-width": "2",
  "stroke-miterlimit": "10",
  d: "M531.528,447.209\n\t\tc4.835,1.428,9.297,3.109,11.469,3.502"
}, null, -1)
const _hoisted_75 = ["fill"]
const _hoisted_76 = /*#__PURE__*/_createElementVNode("path", {
  fill: "none",
  stroke: "#000000",
  "stroke-width": "2",
  "stroke-miterlimit": "10",
  d: "M496.121,475.949\n\t\tc-0.383,7.087,7.879,29.187,10.637,33.847c2.76,4.658,7.483,12.276,10.638,12.628s8.762-4.13,11.43-6.89\n\t\tc2.669-2.76,7.996-12.972,8.904-21.309s0.844-12.582,0.547-16.795c-0.296-4.213-1.172-10.399-4.925-11.795\n\t\tc-3.752-1.394-13.448-3.59-18.485-3S496.921,461.125,496.121,475.949z"
}, null, -1)
const _hoisted_77 = ["fill"]
const _hoisted_78 = /*#__PURE__*/_createElementVNode("path", {
  fill: "none",
  stroke: "#000000",
  "stroke-width": "2",
  "stroke-miterlimit": "10",
  d: "M474.145,540.536\n\t\tc-4.374-1.121-8.883-3.36-11.783-8.541c-2.902-5.181-9.599-18.827-10.1-20.052c-0.841-2.051-0.648-7.127,1.829-11.517\n\t\tc1.306-2.312,3.904-4.243,5.89-5.856c5.753-4.676,14.225-11.035,15.282-11.863s8.261-2.913,15.377,1.096\n\t\tc7.116,4.01,18.414,8.47,17.612,11.967c-0.801,3.497-5.633,22.022-9.358,28.006C495.168,529.757,483.952,543.052,474.145,540.536z"
}, null, -1)
const _hoisted_79 = ["fill"]
const _hoisted_80 = /*#__PURE__*/_createElementVNode("path", {
  fill: "none",
  stroke: "#000000",
  "stroke-width": "2",
  "stroke-miterlimit": "10",
  d: "M427.564,555.198\n\t\tc-3.053-2.053-12.24-11.103-15.602-17.374c-3.26-6.081-5.604-19.963-2.967-29.693c2.637-9.73,9.993-9.259,19.12-8.847\n\t\tc9.732,0.44,15.091,1.591,17.142,1.927c2.052,0.335,8.352,1.007,10.109,10.065c1.76,9.059,1.476,16.987,1.508,17.993\n\t\tc0.133,4.278-2.044,11.421-4.805,15.602c-3.406,5.158-9.983,10.944-12.614,11.161C436.797,556.252,430.092,556.897,427.564,555.198\n\t\tz"
}, null, -1)
const _hoisted_81 = ["fill"]
const _hoisted_82 = /*#__PURE__*/_createElementVNode("path", {
  fill: "none",
  stroke: "#000000",
  "stroke-width": "2",
  "stroke-miterlimit": "10",
  d: "M382.458,565.95\n\t\tc9.375-0.209,21.552-12.798,25.361-33.466s-4.103-28.336-13.626-28.669s-31.493-2.44-35.596-0.44\n\t\tc-4.102,2-5.056,17.441-3.523,24.108C358.426,542.068,367.514,566.284,382.458,565.95z"
}, null, -1)
const _hoisted_83 = ["fill"]
const _hoisted_84 = /*#__PURE__*/_createElementVNode("path", {
  fill: "none",
  stroke: "#000000",
  "stroke-width": "2",
  "stroke-miterlimit": "10",
  d: "M127.074,374.638\n\t\tc-4.68,3.979-15.824,12.637-25.604,12.417c-9.779-0.22-30.547,1.208-34.393-8.571c-3.846-9.78-5.275-20.988,2.417-24.614\n\t\ts11.428-5.934,14.615-8.46c3.187-2.528,10.659-8.989,17.692-7.572c7.032,1.418,11.098,4.165,15.823,5.153\n\t\tc4.725,0.989,8.351,0.439,12.417,0.989c4.066,0.55,10.055,5.935,10.878,8.021c0.823,2.087,2.308,7.143-2.637,13.076\n\t\tS130.202,371.978,127.074,374.638z"
}, null, -1)
const _hoisted_85 = /*#__PURE__*/_createElementVNode("path", {
  fill: "none",
  stroke: "#000000",
  "stroke-width": "2",
  "stroke-miterlimit": "10",
  d: "M125.865,360.462c-2.198,1.209-2.857,0-7.143-3.187\n\t\tc-4.285-3.187-15.823-0.879-18.68-0.549c-0.682,0.078-1.42,0.038-2.2-0.096c-2.487-0.427-5.394-1.806-8.239-3.312\n\t\tc-3.736-1.978-5.366-6.144-10.439-4.495"
}, null, -1)
const _hoisted_86 = /*#__PURE__*/_createElementVNode("path", {
  fill: "none",
  stroke: "#000000",
  "stroke-width": "2",
  "stroke-miterlimit": "10",
  d: "M90.812,366.946c0-2.527,5.619-10.109,7.833-10.219\n\t\t"
}, null, -1)
const _hoisted_87 = /*#__PURE__*/_createElementVNode("path", {
  fill: "none",
  stroke: "#000000",
  "stroke-width": "2",
  "stroke-miterlimit": "10",
  d: "M101.506,356.523\n\t\tc1.613-1.335,6.668-7.049,8.097-9.356"
}, null, -1)
const _hoisted_88 = ["fill"]
const _hoisted_89 = /*#__PURE__*/_createElementVNode("path", {
  fill: "none",
  stroke: "#000000",
  "stroke-width": "2",
  "stroke-miterlimit": "10",
  d: "M144.263,407.949\n\t\tc-9.227,6.949-12.966,10.769-17.472,13.406c-4.505,2.637-14.065,8.461-25.383,5.604c-11.318-2.856-21.867-7.691-25.384-16.372\n\t\tc-3.516-8.682-1.208-18.021,2.198-20.329c3.406-2.308,8.901-2.197,12.856-7.252c3.956-5.055,11.099-6.923,16.044-6.044\n\t\tc4.945,0.879,15.933,4.505,20.988,3.956c5.054-0.55,19.34,0.439,22.746,5.604C154.263,391.686,153.309,401.137,144.263,407.949z"
}, null, -1)
const _hoisted_90 = /*#__PURE__*/_createElementVNode("path", {
  fill: "none",
  stroke: "#000000",
  "stroke-width": "2",
  "stroke-miterlimit": "10",
  d: "M142.504,394.323\n\t\tc-1.428,3.188-9.011,3.517-11.428,1.539c-2.418-1.979-21.757-6.044-25.274-4.945c-3.516,1.099-7.692-1.813-11.537-2.829\n\t\tc-3.846-1.017-8.791-0.862-9.56-0.533"
}, null, -1)
const _hoisted_91 = /*#__PURE__*/_createElementVNode("path", {
  fill: "none",
  stroke: "#000000",
  "stroke-width": "2",
  "stroke-miterlimit": "10",
  d: "M118,384.433c-3.626,0.77-12.52,4.1-13.622,6.72"
}, null, -1)
const _hoisted_92 = /*#__PURE__*/_createElementVNode("path", {
  fill: "none",
  stroke: "#000000",
  "stroke-width": "2",
  "stroke-miterlimit": "10",
  d: "M97.122,405.861\n\t\tc-0.66-1.318,8.256-15.409,11.528-15.1"
}, null, -1)
const _hoisted_93 = ["fill"]
const _hoisted_94 = /*#__PURE__*/_createElementVNode("path", {
  fill: "none",
  stroke: "#000000",
  "stroke-width": "2",
  "stroke-miterlimit": "10",
  d: "M161.586,446.354\n\t\tc-3.982,2.336-14.417,8.681-19.9,10.438c-5.484,1.76-19.329,2.639-25.263,0.881c-5.934-1.759-16.593-12.674-18.79-16.666\n\t\tc-2.198-3.993-2.637-17.398,4.395-19.597c7.033-2.197,14.065-2.967,16.373-5.604c2.308-2.638,11.538-9.011,17.362-7.253\n\t\tc5.823,1.759,10.201,5.385,15.539,5.055c5.339-0.329,19.953,3.518,21.822,8.352C174.992,426.794,173.608,439.301,161.586,446.354z"
}, null, -1)
const _hoisted_95 = /*#__PURE__*/_createElementVNode("path", {
  fill: "none",
  stroke: "#000000",
  "stroke-width": "2",
  "stroke-miterlimit": "10",
  d: "M155.981,429.761\n\t\tc-2.967,1.209-5.934-0.55-11.098-2.088c-5.165-1.538-14.944-2.309-18.241,0c-3.297,2.308-4.725-4.724-9.67-6.044\n\t\tc-4.945-1.318-10.989-1.575-11.318-1.245"
}, null, -1)
const _hoisted_96 = /*#__PURE__*/_createElementVNode("path", {
  fill: "none",
  stroke: "#000000",
  "stroke-width": "2",
  "stroke-miterlimit": "10",
  d: "M145.103,419.322\n\t\tc-4.615,0.439-16.05,5.258-17.365,7.794"
}, null, -1)
const _hoisted_97 = /*#__PURE__*/_createElementVNode("path", {
  fill: "none",
  stroke: "#000000",
  "stroke-width": "2",
  "stroke-miterlimit": "10",
  d: "M118.401,440.201\n\t\tc-0.659-1.979,0.879-6.483,1.978-7.473"
}, null, -1)
const _hoisted_98 = ["fill"]
const _hoisted_99 = /*#__PURE__*/_createElementVNode("path", {
  fill: "none",
  stroke: "#000000",
  "stroke-width": "2",
  "stroke-miterlimit": "10",
  d: "M181.637,474.571\n\t\tc-11.169,8.872-16.153,17.472-25.823,14.614c-9.67-2.856-15.604-13.166-17.911-17.791c-2.308-4.625-5.165-11.768,0-17.042\n\t\tc5.164-5.275,13.845-9.765,18.021-9.883c4.175-0.117,4.505-3.304,9.67-3.304s11.647-1.648,16.043,2.197\n\t\tc4.396,3.847,12.197,10.439,13.296,15.055S183.653,472.969,181.637,474.571z"
}, null, -1)
const _hoisted_100 = /*#__PURE__*/_createElementVNode("path", {
  fill: "none",
  stroke: "#000000",
  "stroke-width": "2",
  "stroke-miterlimit": "10",
  d: "M186.472,458.307\n\t\tc-4.615,1.1-10.659-4.285-15.934-6.373c-5.274-2.088-11.427-1.099-15.603,0c-4.176,1.099-6.813,2.88-9.78,2.648"
}, null, -1)
const _hoisted_101 = /*#__PURE__*/_createElementVNode("path", {
  fill: "none",
  stroke: "#000000",
  "stroke-width": "2",
  "stroke-miterlimit": "10",
  d: "M176.472,447.209\n\t\tc-4.835,1.428-8.647,3.109-11.469,3.502"
}, null, -1)
const _hoisted_102 = ["fill"]
const _hoisted_103 = /*#__PURE__*/_createElementVNode("path", {
  fill: "none",
  stroke: "#000000",
  "stroke-width": "2",
  "stroke-miterlimit": "10",
  d: "M211.879,475.949\n\t\tc0.382,7.087-7.879,29.187-10.637,33.847c-2.759,4.658-7.484,12.276-10.638,12.628c-3.155,0.352-8.762-4.13-11.43-6.89\n\t\ts-7.996-12.972-8.904-21.309c-0.909-8.337-0.843-12.582-0.547-16.795c0.296-4.213,1.172-10.399,4.925-11.795\n\t\tc3.752-1.394,13.448-3.59,18.485-3C198.171,463.225,211.079,461.125,211.879,475.949z"
}, null, -1)
const _hoisted_104 = ["fill"]
const _hoisted_105 = /*#__PURE__*/_createElementVNode("path", {
  fill: "none",
  stroke: "#000000",
  "stroke-width": "2",
  "stroke-miterlimit": "10",
  d: "M233.855,540.536\n\t\tc4.374-1.121,8.882-3.36,11.784-8.541c2.901-5.181,9.598-18.827,10.099-20.052c0.84-2.051,0.649-7.127-1.83-11.517\n\t\tc-1.305-2.312-3.904-4.243-5.889-5.856c-5.753-4.676-14.225-11.035-15.282-11.863c-1.057-0.828-8.261-2.913-15.377,1.096\n\t\tc-7.116,4.01-18.414,8.47-17.612,11.967c0.801,3.497,5.632,22.022,9.358,28.006C212.833,529.757,224.047,543.052,233.855,540.536z"
}, null, -1)
const _hoisted_106 = ["fill"]
const _hoisted_107 = /*#__PURE__*/_createElementVNode("path", {
  fill: "none",
  stroke: "#000000",
  "stroke-width": "2",
  "stroke-miterlimit": "10",
  d: "M280.435,555.198\n\t\tc3.054-2.053,12.24-11.103,15.602-17.374c3.26-6.081,5.605-19.963,2.967-29.693c-2.637-9.73-9.993-9.259-19.12-8.847\n\t\tc-9.733,0.44-15.091,1.591-17.142,1.927c-2.051,0.335-8.351,1.007-10.109,10.065c-1.759,9.059-1.476,16.987-1.508,17.993\n\t\tc-0.133,4.278,2.043,11.421,4.804,15.602c3.406,5.158,9.984,10.944,12.614,11.161C271.203,556.252,277.908,556.897,280.435,555.198\n\t\tz"
}, null, -1)
const _hoisted_108 = ["fill"]
const _hoisted_109 = /*#__PURE__*/_createStaticVNode("<path fill=\"none\" stroke=\"#000000\" stroke-width=\"2\" stroke-miterlimit=\"10\" d=\"M325.542,565.95\n\t\tc-9.375-0.209-21.552-12.798-25.361-33.466s4.102-28.336,13.626-28.669c9.523-0.333,31.492-2.44,35.595-0.44\n\t\tc4.102,2,5.056,17.441,3.524,24.108C349.575,542.068,340.486,566.284,325.542,565.95z\"></path><text transform=\"matrix(1 0 0 1 374 58.3442)\" font-family=\"&#39;MS-PGothic&#39;\" font-size=\"30\">1</text><text transform=\"matrix(1 0 0 1 428 67.1646)\" font-family=\"&#39;MS-PGothic&#39;\" font-size=\"30\">2</text><text transform=\"matrix(1 0 0 1 473 85.1646)\" font-family=\"&#39;MS-PGothic&#39;\" font-size=\"30\">3</text><text transform=\"matrix(1 0 0 1 521.9902 105.8647)\" font-family=\"&#39;MS-PGothic&#39;\" font-size=\"30\">4</text><text transform=\"matrix(1 0 0 1 566 143.8745)\" font-family=\"&#39;MS-PGothic&#39;\" font-size=\"30\">5</text><text transform=\"matrix(1 0 0 1 607.0098 178.8843)\" font-family=\"&#39;MS-PGothic&#39;\" font-size=\"30\">6</text><text transform=\"matrix(1 0 0 1 644 225.894)\" font-family=\"&#39;MS-PGothic&#39;\" font-size=\"30\">7</text><text transform=\"matrix(1 0 0 1 656.9902 279.894)\" font-family=\"&#39;MS-PGothic&#39;\" font-size=\"30\">8</text><text transform=\"matrix(1 0 0 1 374 604.3745)\" font-family=\"&#39;MS-PGothic&#39;\" font-size=\"30\">1</text><text transform=\"matrix(1 0 0 1 428 595.1948)\" font-family=\"&#39;MS-PGothic&#39;\" font-size=\"30\">2</text><text transform=\"matrix(1 0 0 1 473 577.1948)\" font-family=\"&#39;MS-PGothic&#39;\" font-size=\"30\">3</text><text transform=\"matrix(1 0 0 1 521.9902 557.9048)\" font-family=\"&#39;MS-PGothic&#39;\" font-size=\"30\">4</text><text transform=\"matrix(1 0 0 1 566 518.9048)\" font-family=\"&#39;MS-PGothic&#39;\" font-size=\"30\">5</text><text transform=\"matrix(1 0 0 1 607.0098 482.9048)\" font-family=\"&#39;MS-PGothic&#39;\" font-size=\"30\">6</text><text transform=\"matrix(1 0 0 1 644 437.9048)\" font-family=\"&#39;MS-PGothic&#39;\" font-size=\"30\">7</text><text transform=\"matrix(1 0 0 1 656.9902 381.894)\" font-family=\"&#39;MS-PGothic&#39;\" font-size=\"30\">8</text><text transform=\"matrix(1 0 0 1 318.98 604.3745)\" font-family=\"&#39;MS-PGothic&#39;\" font-size=\"30\">1</text><text transform=\"matrix(1 0 0 1 263.9902 595.1938)\" font-family=\"&#39;MS-PGothic&#39;\" font-size=\"30\">2</text><text transform=\"matrix(1 0 0 1 221 577.1938)\" font-family=\"&#39;MS-PGothic&#39;\" font-size=\"30\">3</text><text transform=\"matrix(1 0 0 1 170.9902 557.9048)\" font-family=\"&#39;MS-PGothic&#39;\" font-size=\"30\">4</text><text transform=\"matrix(1 0 0 1 128 518.9048)\" font-family=\"&#39;MS-PGothic&#39;\" font-size=\"30\">5</text><text transform=\"matrix(1 0 0 1 86 482.9048)\" font-family=\"&#39;MS-PGothic&#39;\" font-size=\"30\">6</text><text transform=\"matrix(1 0 0 1 50 437.9048)\" font-family=\"&#39;MS-PGothic&#39;\" font-size=\"30\">7</text><text transform=\"matrix(1 0 0 1 35.9902 381.894)\" font-family=\"&#39;MS-PGothic&#39;\" font-size=\"30\">8</text><text transform=\"matrix(1 0 0 1 318.98 58.3745)\" font-family=\"&#39;MS-PGothic&#39;\" font-size=\"30\">1</text><text transform=\"matrix(1 0 0 1 263.9902 67.1943)\" font-family=\"&#39;MS-PGothic&#39;\" font-size=\"30\">2</text><text transform=\"matrix(1 0 0 1 221 85.1943)\" font-family=\"&#39;MS-PGothic&#39;\" font-size=\"30\">3</text><text transform=\"matrix(1 0 0 1 170.9902 105.894)\" font-family=\"&#39;MS-PGothic&#39;\" font-size=\"30\">4</text><text transform=\"matrix(1 0 0 1 128 143.9048)\" font-family=\"&#39;MS-PGothic&#39;\" font-size=\"30\">5</text><text transform=\"matrix(1 0 0 1 86 178.9146)\" font-family=\"&#39;MS-PGothic&#39;\" font-size=\"30\">6</text><text transform=\"matrix(1 0 0 1 50 225.9243)\" font-family=\"&#39;MS-PGothic&#39;\" font-size=\"30\">7</text><text transform=\"matrix(1 0 0 1 35.9902 279.9243)\" font-family=\"&#39;MS-PGothic&#39;\" font-size=\"30\">8</text><line fill=\"none\" stroke=\"#000000\" stroke-width=\"2\" stroke-miterlimit=\"10\" x1=\"354.092\" y1=\"653.348\" x2=\"354.092\" y2=\"0\"></line><line fill=\"none\" stroke=\"#000000\" stroke-width=\"2\" stroke-miterlimit=\"10\" x1=\"708\" y1=\"315.674\" x2=\"0\" y2=\"315.674\"></line><text transform=\"matrix(1 0 0 1 595.5 48.9868)\" font-family=\"&#39;MS-PGothic&#39;\" font-size=\"28\">上顎左側</text><text transform=\"matrix(1 0 0 1 0.5 57.9746)\" font-family=\"&#39;MS-PGothic&#39;\" font-size=\"28\">上顎右側</text><text transform=\"matrix(1 0 0 1 0.5005 615.814)\" font-family=\"&#39;MS-PGothic&#39;\" font-size=\"28\">下顎右側</text><text transform=\"matrix(1 0 0 1 595.5 615.9819)\" font-family=\"&#39;MS-PGothic&#39;\" font-size=\"28\">下顎左側</text>", 39)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [
    _createElementVNode("g", null, [
      _createElementVNode("path", {
        fill: _ctx.exams.ul8.color,
        d: "M580.926,258.908c4.68-3.979,15.823-12.637,25.604-12.417c9.779,0.22,30.548-1.209,34.394,8.571\n\t\tc3.847,9.779,5.274,20.987-2.417,24.614c-7.692,3.626-11.429,5.934-14.615,8.46c-3.187,2.528-10.658,8.988-17.691,7.571\n\t\tc-7.032-1.417-11.099-4.164-15.823-5.154c-4.725-0.987-8.352-0.438-12.417-0.987c-4.065-0.55-10.056-5.935-10.879-8.022\n\t\tc-0.822-2.087-2.308-7.143,2.638-13.076C574.662,262.534,577.798,261.568,580.926,258.908"
      }, null, 8, _hoisted_2),
      _hoisted_3,
      _hoisted_4,
      _hoisted_5,
      _hoisted_6,
      _createElementVNode("path", {
        fill: _ctx.exams.ul7.color,
        d: "M563.737,225.596c9.227-6.949,12.967-10.769,17.472-13.405c4.506-2.638,14.065-8.462,25.383-5.604\n\t\tc11.319,2.857,21.868,7.692,25.384,16.373c3.517,8.681,1.209,18.021-2.197,20.328s-8.9,2.198-12.856,7.253\n\t\ts-11.099,6.923-16.043,6.044c-4.945-0.88-15.934-4.506-20.988-3.956c-5.055,0.549-19.34-0.439-22.746-5.604\n\t\tC553.738,241.86,554.691,232.41,563.737,225.596"
      }, null, 8, _hoisted_7),
      _hoisted_8,
      _hoisted_9,
      _hoisted_10,
      _hoisted_11,
      _createElementVNode("path", {
        fill: _ctx.exams.ul6.color,
        d: "M546.414,187.192c3.982-2.336,14.418-8.682,19.9-10.439c5.483-1.758,19.328-2.638,25.263-0.879\n\t\tc5.934,1.758,16.593,12.674,18.79,16.666c2.198,3.992,2.638,17.398-4.396,19.596c-7.032,2.198-14.065,2.967-16.372,5.604\n\t\tc-2.308,2.638-11.538,9.011-17.362,7.252c-5.824-1.758-10.201-5.384-15.54-5.055c-5.338,0.33-19.953-3.517-21.821-8.351\n\t\tC533.009,206.752,534.393,194.244,546.414,187.192"
      }, null, 8, _hoisted_12),
      _hoisted_13,
      _hoisted_14,
      _hoisted_15,
      _hoisted_16,
      _createElementVNode("path", {
        fill: _ctx.exams.ul5.color,
        d: "M526.363,158.975c11.169-8.872,16.153-17.472,25.823-14.615c9.67,2.857,15.604,13.167,17.911,17.792\n\t\ts5.164,11.768,0,17.042c-5.165,5.274-13.846,9.765-18.021,9.882s-4.505,3.305-9.67,3.305c-5.164,0-11.646,1.647-16.043-2.198\n\t\ts-12.197-10.438-13.296-15.054C511.969,170.513,524.348,160.577,526.363,158.975"
      }, null, 8, _hoisted_17),
      _hoisted_18,
      _hoisted_19,
      _hoisted_20,
      _createElementVNode("path", {
        fill: _ctx.exams.ul4.color,
        d: "M496.121,157.596c-0.383-7.087,7.879-29.187,10.637-33.846c2.76-4.659,7.483-12.276,10.638-12.628\n\t\ts8.762,4.129,11.43,6.889c2.669,2.76,7.996,12.972,8.904,21.309c0.908,8.339,0.844,12.582,0.547,16.796\n\t\tc-0.296,4.212-1.172,10.399-4.925,11.794c-3.752,1.395-13.448,3.591-18.485,3.001S496.921,172.421,496.121,157.596"
      }, null, 8, _hoisted_21),
      _hoisted_22,
      _createElementVNode("path", {
        fill: _ctx.exams.ul3.color,
        d: "M474.145,93.009c-4.374,1.122-8.883,3.36-11.783,8.542c-2.902,5.181-9.599,18.827-10.1,20.052\n\t\tc-0.841,2.052-0.648,7.126,1.829,11.516c1.306,2.312,3.904,4.243,5.89,5.856c5.753,4.676,14.225,11.036,15.282,11.863\n\t\tc1.058,0.828,8.261,2.914,15.377-1.096s18.414-8.47,17.612-11.967c-0.801-3.496-5.633-22.022-9.358-28.005\n\t\tC495.168,103.788,483.952,90.493,474.145,93.009"
      }, null, 8, _hoisted_23),
      _hoisted_24,
      _createElementVNode("path", {
        fill: _ctx.exams.ul2.color,
        d: "M427.564,78.348c-3.053,2.053-12.24,11.102-15.602,17.374c-3.26,6.081-5.604,19.963-2.967,29.694\n\t\tc2.637,9.729,9.993,9.259,19.12,8.847c9.732-0.441,15.091-1.592,17.142-1.927c2.052-0.336,8.352-1.007,10.109-10.065\n\t\tc1.76-9.06,1.476-16.987,1.508-17.993c0.133-4.278-2.044-11.421-4.805-15.601c-3.406-5.159-9.983-10.945-12.614-11.162\n\t\tC436.797,77.294,430.092,76.649,427.564,78.348"
      }, null, 8, _hoisted_25),
      _hoisted_26,
      _createElementVNode("path", {
        fill: _ctx.exams.ul1.color,
        d: "M382.458,67.596c9.375,0.209,21.552,12.798,25.361,33.466c3.81,20.668-4.103,28.335-13.626,28.669\n\t\tc-9.523,0.333-31.493,2.44-35.596,0.44c-4.102-2-5.056-17.442-3.523-24.109C358.426,91.477,367.514,67.263,382.458,67.596"
      }, null, 8, _hoisted_27),
      _hoisted_28,
      _createElementVNode("path", {
        fill: _ctx.exams.ur8.color,
        d: "M127.074,258.908c-4.68-3.979-15.824-12.637-25.604-12.417c-9.779,0.22-30.547-1.209-34.393,8.571\n\t\tc-3.846,9.779-5.275,20.987,2.417,24.614c7.692,3.626,11.428,5.934,14.615,8.46c3.187,2.528,10.659,8.988,17.692,7.571\n\t\tc7.032-1.417,11.098-4.164,15.823-5.154c4.725-0.987,8.351-0.438,12.417-0.987c4.066-0.55,10.055-5.935,10.878-8.022\n\t\tc0.823-2.087,2.308-7.143-2.637-13.076S130.202,261.568,127.074,258.908"
      }, null, 8, _hoisted_29),
      _hoisted_30,
      _hoisted_31,
      _hoisted_32,
      _hoisted_33,
      _createElementVNode("path", {
        fill: _ctx.exams.ur7.color,
        d: "M144.263,225.596c-9.227-6.949-12.966-10.769-17.472-13.405c-4.505-2.638-14.065-8.462-25.383-5.604\n\t\ts-21.867,7.692-25.384,16.373c-3.516,8.681-1.208,18.021,2.198,20.328c3.406,2.308,8.901,2.198,12.856,7.253\n\t\tc3.956,5.055,11.099,6.923,16.044,6.044c4.945-0.88,15.933-4.506,20.988-3.956c5.054,0.549,19.34-0.439,22.746-5.604\n\t\tC154.263,241.86,153.309,232.41,144.263,225.596"
      }, null, 8, _hoisted_34),
      _hoisted_35,
      _hoisted_36,
      _hoisted_37,
      _hoisted_38,
      _createElementVNode("path", {
        fill: _ctx.exams.ur6.color,
        d: "M161.586,187.192c-3.982-2.336-14.417-8.682-19.9-10.439c-5.484-1.758-19.329-2.638-25.263-0.879\n\t\tc-5.934,1.758-16.593,12.674-18.79,16.666c-2.198,3.992-2.637,17.398,4.395,19.596c7.033,2.198,14.065,2.967,16.373,5.604\n\t\ts11.538,9.011,17.362,7.252c5.823-1.758,10.201-5.384,15.539-5.055c5.339,0.33,19.953-3.517,21.822-8.351\n\t\tC174.992,206.752,173.608,194.244,161.586,187.192"
      }, null, 8, _hoisted_39),
      _hoisted_40,
      _hoisted_41,
      _hoisted_42,
      _hoisted_43,
      _createElementVNode("path", {
        fill: _ctx.exams.ur5.color,
        d: "M181.637,158.975c-11.169-8.872-16.153-17.472-25.823-14.615c-9.67,2.857-15.604,13.167-17.911,17.792\n\t\tc-2.308,4.625-5.165,11.768,0,17.042c5.164,5.274,13.845,9.765,18.021,9.882c4.175,0.117,4.505,3.305,9.67,3.305\n\t\ts11.647,1.647,16.043-2.198s12.197-10.438,13.296-15.054C196.032,170.513,183.653,160.577,181.637,158.975"
      }, null, 8, _hoisted_44),
      _hoisted_45,
      _hoisted_46,
      _hoisted_47,
      _createElementVNode("path", {
        fill: _ctx.exams.ur4.color,
        d: "M211.879,157.596c0.382-7.087-7.879-29.187-10.637-33.846c-2.759-4.659-7.484-12.276-10.638-12.628\n\t\tc-3.155-0.352-8.762,4.129-11.43,6.889s-7.996,12.972-8.904,21.309c-0.909,8.339-0.843,12.582-0.547,16.796\n\t\tc0.296,4.212,1.172,10.399,4.925,11.794c3.752,1.395,13.448,3.591,18.485,3.001C198.171,170.321,211.079,172.421,211.879,157.596"
      }, null, 8, _hoisted_48),
      _hoisted_49,
      _createElementVNode("path", {
        fill: _ctx.exams.ur3.color,
        d: "M233.855,93.009c4.374,1.122,8.882,3.36,11.784,8.542c2.901,5.181,9.598,18.827,10.099,20.052\n\t\tc0.84,2.052,0.649,7.126-1.83,11.516c-1.305,2.312-3.904,4.243-5.889,5.856c-5.753,4.676-14.225,11.036-15.282,11.863\n\t\tc-1.057,0.828-8.261,2.914-15.377-1.096c-7.116-4.01-18.414-8.47-17.612-11.967c0.801-3.496,5.632-22.022,9.358-28.005\n\t\tC212.833,103.788,224.047,90.493,233.855,93.009"
      }, null, 8, _hoisted_50),
      _hoisted_51,
      _createElementVNode("path", {
        fill: _ctx.exams.ur2.color,
        d: "M280.435,78.348c3.054,2.053,12.24,11.102,15.602,17.374c3.26,6.081,5.605,19.963,2.967,29.694\n\t\tc-2.637,9.729-9.993,9.259-19.12,8.847c-9.733-0.441-15.091-1.592-17.142-1.927c-2.051-0.336-8.351-1.007-10.109-10.065\n\t\tc-1.759-9.06-1.476-16.987-1.508-17.993c-0.133-4.278,2.043-11.421,4.804-15.601c3.406-5.159,9.984-10.945,12.614-11.162\n\t\tC271.203,77.294,277.908,76.649,280.435,78.348"
      }, null, 8, _hoisted_52),
      _hoisted_53,
      _createElementVNode("path", {
        fill: _ctx.exams.ur1.color,
        d: "M325.542,67.596c-9.375,0.209-21.552,12.798-25.361,33.466c-3.809,20.668,4.102,28.335,13.626,28.669\n\t\tc9.523,0.333,31.492,2.44,35.595,0.44c4.102-2,5.056-17.442,3.524-24.109C349.575,91.477,340.486,67.263,325.542,67.596"
      }, null, 8, _hoisted_54),
      _hoisted_55,
      _createElementVNode("path", {
        fill: _ctx.exams.bl8.color,
        d: "M580.926,374.638c4.68,3.979,15.823,12.637,25.604,12.417c9.779-0.22,30.548,1.208,34.394-8.571\n\t\tc3.847-9.78,5.274-20.988-2.417-24.614c-7.692-3.626-11.429-5.934-14.615-8.46c-3.187-2.528-10.658-8.989-17.691-7.572\n\t\tc-7.032,1.418-11.099,4.165-15.823,5.153c-4.725,0.989-8.352,0.439-12.417,0.989s-10.056,5.935-10.879,8.021\n\t\tc-0.822,2.087-2.308,7.143,2.638,13.076C574.662,371.011,577.798,371.978,580.926,374.638"
      }, null, 8, _hoisted_56),
      _hoisted_57,
      _hoisted_58,
      _hoisted_59,
      _hoisted_60,
      _createElementVNode("path", {
        fill: _ctx.exams.bl7.color,
        d: "M563.737,407.949c9.227,6.949,12.967,10.769,17.472,13.406c4.506,2.637,14.065,8.461,25.383,5.604\n\t\tc11.319-2.856,21.868-7.691,25.384-16.372c3.517-8.682,1.209-18.021-2.197-20.329s-8.9-2.197-12.856-7.252\n\t\ts-11.099-6.923-16.043-6.044c-4.945,0.879-15.934,4.505-20.988,3.956c-5.055-0.55-19.34,0.439-22.746,5.604\n\t\tC553.738,391.686,554.691,401.137,563.737,407.949"
      }, null, 8, _hoisted_61),
      _hoisted_62,
      _hoisted_63,
      _hoisted_64,
      _hoisted_65,
      _createElementVNode("path", {
        fill: _ctx.exams.bl6.color,
        d: "M546.414,446.354c3.982,2.336,14.418,8.681,19.9,10.438c5.483,1.76,19.328,2.639,25.263,0.881\n\t\tc5.934-1.759,16.593-12.674,18.79-16.666c2.198-3.993,2.638-17.398-4.396-19.597c-7.032-2.197-14.065-2.967-16.372-5.604\n\t\tc-2.308-2.638-11.538-9.011-17.362-7.253c-5.824,1.759-10.201,5.385-15.54,5.055c-5.338-0.329-19.953,3.518-21.821,8.352\n\t\tC533.009,426.794,534.393,439.301,546.414,446.354"
      }, null, 8, _hoisted_66),
      _hoisted_67,
      _hoisted_68,
      _hoisted_69,
      _hoisted_70,
      _createElementVNode("path", {
        fill: _ctx.exams.bl5.color,
        d: "M526.363,474.571c11.169,8.872,16.153,17.472,25.823,14.614c9.67-2.856,15.604-13.166,17.911-17.791\n\t\ts5.164-11.768,0-17.042c-5.165-5.275-13.846-9.765-18.021-9.883c-4.176-0.117-4.505-3.304-9.67-3.304\n\t\tc-5.164,0-11.646-1.648-16.043,2.197c-4.396,3.847-12.197,10.439-13.296,15.055S524.348,472.969,526.363,474.571"
      }, null, 8, _hoisted_71),
      _hoisted_72,
      _hoisted_73,
      _hoisted_74,
      _createElementVNode("path", {
        fill: _ctx.exams.bl4.color,
        d: "M496.121,475.949c-0.383,7.087,7.879,29.187,10.637,33.847c2.76,4.658,7.483,12.276,10.638,12.628\n\t\ts8.762-4.13,11.43-6.89c2.669-2.76,7.996-12.972,8.904-21.309s0.844-12.582,0.547-16.795c-0.296-4.213-1.172-10.399-4.925-11.795\n\t\tc-3.752-1.394-13.448-3.59-18.485-3S496.921,461.125,496.121,475.949"
      }, null, 8, _hoisted_75),
      _hoisted_76,
      _createElementVNode("path", {
        fill: _ctx.exams.bl3.color,
        d: "M474.145,540.536c-4.374-1.121-8.883-3.36-11.783-8.541c-2.902-5.181-9.599-18.827-10.1-20.052\n\t\tc-0.841-2.051-0.648-7.127,1.829-11.517c1.306-2.312,3.904-4.243,5.89-5.856c5.753-4.676,14.225-11.035,15.282-11.863\n\t\ts8.261-2.913,15.377,1.096c7.116,4.01,18.414,8.47,17.612,11.967c-0.801,3.497-5.633,22.022-9.358,28.006\n\t\tC495.168,529.757,483.952,543.052,474.145,540.536"
      }, null, 8, _hoisted_77),
      _hoisted_78,
      _createElementVNode("path", {
        fill: _ctx.exams.bl2.color,
        d: "M427.564,555.198c-3.053-2.053-12.24-11.103-15.602-17.374c-3.26-6.081-5.604-19.963-2.967-29.693\n\t\tc2.637-9.73,9.993-9.259,19.12-8.847c9.732,0.44,15.091,1.591,17.142,1.927c2.052,0.335,8.352,1.007,10.109,10.065\n\t\tc1.76,9.059,1.476,16.987,1.508,17.993c0.133,4.278-2.044,11.421-4.805,15.602c-3.406,5.158-9.983,10.944-12.614,11.161\n\t\tC436.797,556.252,430.092,556.897,427.564,555.198"
      }, null, 8, _hoisted_79),
      _hoisted_80,
      _createElementVNode("path", {
        fill: _ctx.exams.bl1.color,
        d: "M382.458,565.95c9.375-0.209,21.552-12.798,25.361-33.466s-4.103-28.336-13.626-28.669\n\t\ts-31.493-2.44-35.596-0.44c-4.102,2-5.056,17.441-3.523,24.108C358.426,542.068,367.514,566.284,382.458,565.95"
      }, null, 8, _hoisted_81),
      _hoisted_82,
      _createElementVNode("path", {
        fill: _ctx.exams.br8.color,
        d: "M127.074,374.638c-4.68,3.979-15.824,12.637-25.604,12.417c-9.779-0.22-30.547,1.208-34.393-8.571\n\t\tc-3.846-9.78-5.275-20.988,2.417-24.614s11.428-5.934,14.615-8.46c3.187-2.528,10.659-8.989,17.692-7.572\n\t\tc7.032,1.418,11.098,4.165,15.823,5.153c4.725,0.989,8.351,0.439,12.417,0.989c4.066,0.55,10.055,5.935,10.878,8.021\n\t\tc0.823,2.087,2.308,7.143-2.637,13.076S130.202,371.978,127.074,374.638"
      }, null, 8, _hoisted_83),
      _hoisted_84,
      _hoisted_85,
      _hoisted_86,
      _hoisted_87,
      _createElementVNode("path", {
        fill: _ctx.exams.br7.color,
        d: "M144.263,407.949c-9.227,6.949-12.966,10.769-17.472,13.406c-4.505,2.637-14.065,8.461-25.383,5.604\n\t\tc-11.318-2.856-21.867-7.691-25.384-16.372c-3.516-8.682-1.208-18.021,2.198-20.329c3.406-2.308,8.901-2.197,12.856-7.252\n\t\tc3.956-5.055,11.099-6.923,16.044-6.044c4.945,0.879,15.933,4.505,20.988,3.956c5.054-0.55,19.34,0.439,22.746,5.604\n\t\tC154.263,391.686,153.309,401.137,144.263,407.949"
      }, null, 8, _hoisted_88),
      _hoisted_89,
      _hoisted_90,
      _hoisted_91,
      _hoisted_92,
      _createElementVNode("path", {
        fill: _ctx.exams.br6.color,
        d: "M161.586,446.354c-3.982,2.336-14.417,8.681-19.9,10.438c-5.484,1.76-19.329,2.639-25.263,0.881\n\t\tc-5.934-1.759-16.593-12.674-18.79-16.666c-2.198-3.993-2.637-17.398,4.395-19.597c7.033-2.197,14.065-2.967,16.373-5.604\n\t\tc2.308-2.638,11.538-9.011,17.362-7.253c5.823,1.759,10.201,5.385,15.539,5.055c5.339-0.329,19.953,3.518,21.822,8.352\n\t\tC174.992,426.794,173.608,439.301,161.586,446.354"
      }, null, 8, _hoisted_93),
      _hoisted_94,
      _hoisted_95,
      _hoisted_96,
      _hoisted_97,
      _createElementVNode("path", {
        fill: _ctx.exams.br5.color,
        d: "M181.637,474.571c-11.169,8.872-16.153,17.472-25.823,14.614c-9.67-2.856-15.604-13.166-17.911-17.791\n\t\tc-2.308-4.625-5.165-11.768,0-17.042c5.164-5.275,13.845-9.765,18.021-9.883c4.175-0.117,4.505-3.304,9.67-3.304\n\t\ts11.647-1.648,16.043,2.197c4.396,3.847,12.197,10.439,13.296,15.055S183.653,472.969,181.637,474.571"
      }, null, 8, _hoisted_98),
      _hoisted_99,
      _hoisted_100,
      _hoisted_101,
      _createElementVNode("path", {
        fill: _ctx.exams.br4.color,
        d: "M211.879,475.949c0.382,7.087-7.879,29.187-10.637,33.847c-2.759,4.658-7.484,12.276-10.638,12.628\n\t\tc-3.155,0.352-8.762-4.13-11.43-6.89s-7.996-12.972-8.904-21.309c-0.909-8.337-0.843-12.582-0.547-16.795\n\t\tc0.296-4.213,1.172-10.399,4.925-11.795c3.752-1.394,13.448-3.59,18.485-3C198.171,463.225,211.079,461.125,211.879,475.949"
      }, null, 8, _hoisted_102),
      _hoisted_103,
      _createElementVNode("path", {
        fill: _ctx.exams.br3.color,
        d: "M233.855,540.536c4.374-1.121,8.882-3.36,11.784-8.541c2.901-5.181,9.598-18.827,10.099-20.052\n\t\tc0.84-2.051,0.649-7.127-1.83-11.517c-1.305-2.312-3.904-4.243-5.889-5.856c-5.753-4.676-14.225-11.035-15.282-11.863\n\t\tc-1.057-0.828-8.261-2.913-15.377,1.096c-7.116,4.01-18.414,8.47-17.612,11.967c0.801,3.497,5.632,22.022,9.358,28.006\n\t\tC212.833,529.757,224.047,543.052,233.855,540.536"
      }, null, 8, _hoisted_104),
      _hoisted_105,
      _createElementVNode("path", {
        fill: _ctx.exams.br2.color,
        d: "M280.435,555.198c3.054-2.053,12.24-11.103,15.602-17.374c3.26-6.081,5.605-19.963,2.967-29.693\n\t\tc-2.637-9.73-9.993-9.259-19.12-8.847c-9.733,0.44-15.091,1.591-17.142,1.927c-2.051,0.335-8.351,1.007-10.109,10.065\n\t\tc-1.759,9.059-1.476,16.987-1.508,17.993c-0.133,4.278,2.043,11.421,4.804,15.602c3.406,5.158,9.984,10.944,12.614,11.161\n\t\tC271.203,556.252,277.908,556.897,280.435,555.198"
      }, null, 8, _hoisted_106),
      _hoisted_107,
      _createElementVNode("path", {
        fill: _ctx.exams.br1.color,
        d: "M325.542,565.95c-9.375-0.209-21.552-12.798-25.361-33.466s4.102-28.336,13.626-28.669\n\t\tc9.523-0.333,31.492-2.44,35.595-0.44c4.102,2,5.056,17.441,3.524,24.108C349.575,542.068,340.486,566.284,325.542,565.95"
      }, null, 8, _hoisted_108),
      _hoisted_109
    ])
  ]))
}